import store from '@/store';
import EventBus from '@/utils/eventBus';

function preventPageLeave(event) {
    event.preventDefault();
}

store.subscribe((mutation) => {
    if (mutation.type !== 'SET_NAVIGATION_LOCK' && mutation.type !== 'CLEAR_NAVIGATION_LOCK') {
        return;
    }

    if (store.getters.isNavigationLockActive) {
        window.addEventListener('beforeunload', preventPageLeave);
    } else {
        window.removeEventListener('beforeunload', preventPageLeave);
    }
});

function isSameRoute(from, to) {
    return from.path === to.path && from.name === to.name;
}

export default function navigationLockGuard(to, from, next) {
    if (!from.matched.length || !store.getters.isNavigationLockActive) {
        return next();
    }

    if (isSameRoute(to, from)) {
        return next();
    }

    const pendingTo = store.getters.navigationLockPendingNavigation?.to;
    if (pendingTo && isSameRoute(to, pendingTo)) {
        return next(false);
    }

    store.commit('SET_NAVIGATION_LOCK', { pendingNavigation: { to } });
    EventBus.emit('show-modal', 'navigation-lock-modal');
    return next(false);
}
